export default function Spinner() {
  return (
    <img className="gif" src={'/images/icons8-top-view-fish.gif'} style={{ height: '300px' }}/>
  );
}
